/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SharedContactDealerWrapper_user$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedMakeOfferButton_user$ref: FragmentReference;
export type PdpSharedMakeOfferButton_user = {|
  +profile: ?{|
    +currency: ?Currency
  |},
  +$fragmentRefs: SharedContactDealerWrapper_user$ref,
  +$refType: PdpSharedMakeOfferButton_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedMakeOfferButton_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "currency",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6566dfb682a0449e8b6d43ffa64a5175';
module.exports = node;
